// extracted by mini-css-extract-plugin
export var container = "_a5-0";
export var icon = "_a5-1";
export var text = "_a5-2";